import { SxProps } from '@mui/system';
import { FullHeightWithoutTopBar, OverflowForDesktop } from '10.quickConnect.app/components/shared/LayOut/TopBar/style';

export const MainBox: SxProps = {
  width: '100%',
  minHeight: FullHeightWithoutTopBar,
  overflowY: OverflowForDesktop,
};
